import { render, staticRenderFns } from "./Pageing.vue?vue&type=template&id=06e94799&scoped=true"
import script from "./Pageing.vue?vue&type=script&lang=js"
export * from "./Pageing.vue?vue&type=script&lang=js"
import style0 from "./Pageing.vue?vue&type=style&index=0&id=06e94799&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e94799",
  null
  
)

export default component.exports